import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import SwiperCore from 'swiper';

import { Nullish } from '@tager/web-core';

import { SliderModalProps } from '@/components/DetailedCarGallery/DetailedCarGallery.types';
import VerticalSlider from '@/components/DetailedCarGallery/components/VerticalSlider';
import BigSliderModal from '@/components/DetailedCarGallery/components/BigSliderModal';
import BottomSliderModal from '@/components/DetailedCarGallery/components/BottomSliderModal';
import CloseButton from '@/components/modals/shared/CloseButton';

function SliderModal({ innerProps, closeModal }: SliderModalProps) {
  const [thumbsSwiper, setThumbsSwiper] = useState<Nullish<SwiperCore>>(null);

  const {
    images,
    currentSlideIndex,
    setCurrentSlideIndex,
    isMobile,
    subneilsPerView,
    onClose,
  } = innerProps;
  const [modalSlideIndex, setModalSlideIndex] = useState(currentSlideIndex);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      if (onClose) {
        onClose();
      }
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <Component isMobile={isMobile}>
      <CloseButton onClick={closeModal} />

      {isMobile ? (
        <VerticalSlider
          images={images}
          setCurrentSlideIndex={setCurrentSlideIndex}
          currentSlideIndex={currentSlideIndex}
        />
      ) : (
        <BigSliderModal
          images={images}
          currentSlideIndex={currentSlideIndex}
          setCurrentSlideIndex={setCurrentSlideIndex}
          thumbsSwiper={thumbsSwiper}
          isMobile={isMobile}
          subneilsPerView={subneilsPerView}
          setModalSlideIndex={setModalSlideIndex}
        />
      )}

      {images.length > 1 && !isMobile && (
        <BottomSliderModal
          images={images}
          setSlider={setThumbsSwiper}
          subneilsPerView={subneilsPerView}
          currentSlideIndex={modalSlideIndex}
        />
      )}
    </Component>
  );
}

export default SliderModal;

const Component = styled.div<{ isMobile: boolean }>`
  width: calc(100vw - 20px);
  max-width: 60vw;

  ${({ isMobile }) =>
    isMobile &&
    css`
      max-width: none;
    `}
`;
